import React, { useEffect, useState, FormEvent } from "react";
import { useParams } from "react-router-dom";

import { ICertificationPayment } from "./types";
import { formatDate, formatPaymentMethod } from "./types";

const Certification = () => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");

  const [showCertificationForm, setShowCertificationForm] = useState(false);
  const [certificationPayment, setCertificationPayment] = useState<ICertificationPayment | null>(null);

  const privilege = parseInt(localStorage.getItem("privilege") || "0");
  const canModifyPayments = privilege === 1 || privilege === 2;

  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [certificationPaidAt, setCertificationPaidAt] = useState("");
  const [certificationPaymentMethod, setCertificationPaymentMethod] = useState("");
  const [certificationReferenceNumber, setCertificationReferenceNumber] = useState("");
  const [certificationAmount, setCertificationAmount] = useState(0);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/certification/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCertificationPayment(data.certificationPayment);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error al obtener pagos:", err);
        setIsLoading(false);
      });
  }, [refreshTrigger]);

  const handleCertificationPaymentSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!certificationPaymentMethod) {
      setMessage("Selecciona un método de pago válido");
      return;
    }

    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/certification/manual/${id}`, {
        method: certificationPayment?.paid ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paidAt: new Date(certificationPaidAt).toISOString(),
          amount: certificationAmount,
          paymentMethod: certificationPaymentMethod,
          referenceNumber: certificationReferenceNumber,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Fallo al registrar/modificar pago de certificación");

      setShowCertificationForm(false);
      setRefreshTrigger((prev) => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/certification/manual/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Fallo al eliminar pago de certificación");

      setRefreshTrigger((prev) => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="flex flex-col items-start gap-8 w-full mt-8">
      <div className="w-full flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Pago de certificación</h2>
        {canModifyPayments && (
          <button
            onClick={() => setShowCertificationForm(true)}
            className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-full sm:w-1/4 shadow-lg py-2"
          >
            Registrar pago certificación
          </button>
        )}
      </div>

      {showCertificationForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
          <div className="bg-[#d9d9d9] w-full sm:w-2/4 max-h-[90%] overflow-y-auto p-6 rounded-lg shadow-lg relative">
            <button className="absolute top-2 right-2 text-gray-800 text-lg" onClick={() => setShowCertificationForm(false)}>x</button>
            <form onSubmit={handleCertificationPaymentSubmit} className="w-full flex flex-col gap-3">
              <label>Tipo de pago</label>
              <select value={certificationPaymentMethod} onChange={(e) => setCertificationPaymentMethod(e.target.value)} >
                <option value="">Selecciona un método</option>
                <option value="transferencia">Transferencia</option>
                <option value="deposito">Depósito</option>
              </select>

              <label>Fecha</label>
              <input type="date" value={certificationPaidAt} onChange={(e) => setCertificationPaidAt(e.target.value)}  />

              <label>Número de referencia</label>
              <input type="text" value={certificationReferenceNumber} onChange={(e) => setCertificationReferenceNumber(e.target.value)}  />

              <label>Monto</label>
              <input type="number" value={certificationAmount} onChange={(e) => setCertificationAmount(Number(e.target.value))}  />

              <button type="submit" className="mt-4 bg-[#1c1c2e] text-white py-2 rounded-md">
                {certificationPayment?.paid ? "Actualizar" : "Registrar"} pago de certificación
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="w-full flex flex-col">
        {isLoading ? (
          <p>Cargando estado de certificación...</p>
        ) : certificationPayment && certificationPayment.paid ? (
          <div className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-8">
            <p className="font-sourceSans text-sm sm:text-base">
              El estudiante pagó la certificación el día <strong>{formatDate(certificationPayment.paidAt)}</strong> mediante {" "}
              <strong>{formatPaymentMethod(certificationPayment.paymentMethod)}</strong>. Monto: <strong>${certificationPayment.amount} MXN</strong>
            </p>
            {canModifyPayments && (
              <div className="flex flex-col sm:flex-row gap-2 mt-2 sm:mt-0">
                <button
                  onClick={() => setShowCertificationForm(true)}
                  className="bg-[#1c1c2e] text-white text-sm px-4 py-1 rounded-md"
                >
                  Editar
                </button>
                <button
                  onClick={handleDelete}
                  className="bg-red-600 text-white text-sm px-4 py-1 rounded-md"
                >
                  Eliminar
                </button>
              </div>
            )}
          </div>
        ) : (
          <p className="font-sourceSans px-4">El estudiante aún no ha pagado su certificación.</p>
        )}
      </div>

      {message && <p className="text-red-600 font-sourceSans px-4">{message}</p>}
    </div>
  );
};

export default Certification;
